module.exports = __webpack_public_path__ + "img/loan-agreement-icon.95d30b57.svg";